import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, map, Observable, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';
import {
    DrillDownPayload,
    DrillDownResponse,
    MatrixFromToPayload,
    MatrixFromToResponse,
    NedistribuiteDrillPayload,
    NedistribuiteDrillResponse,
    NedistribuiteResponse,
} from './raport-activitate-detaliat.interface';

@Injectable({ providedIn: 'root' })
export class RaportActivitateDetaliatService {
    private basePath = environment.interop.basePath;

    private cfg = environment.interop.indoc.rapoarteActivitatiMatrix;

    public matrixUrl = this.basePath + this.cfg.list;
    public drillDownUrl = this.basePath + this.cfg.drillDown;
    public exportCsvUrl = this.basePath + this.cfg.exportCsv;
    public exportPdfUrl = this.basePath + this.cfg.exportPdf;

    // derivate din prefixul .../activity-matrix/ (fără a modifica fișierele de environment)
    private matrixBase = this.basePath + this.cfg.list.replace(/list$/, '');
    public nedistribuiteUrl = this.matrixBase + 'nedistribuite';
    public nedistribuiteDrillDownUrl = this.matrixBase + 'nedistribuite/drill-down';

    constructor(private http: HttpClient) {}

    getMatrix(payload: MatrixFromToPayload): Observable<MatrixFromToResponse> {
        return this.http
            .post<{ errors: boolean; data: MatrixFromToResponse; status_code: number }>(this.matrixUrl, payload)
            .pipe(
                map((response) => response.data),
                catchError((error) => {
                    console.error('Error in matrix request:', error);
                    return throwError(() => error);
                }),
            );
    }

    getDrillDownDocuments(payload: DrillDownPayload): Observable<DrillDownResponse> {
        return this.http.post<DrillDownResponse>(this.drillDownUrl, payload).pipe(
            catchError((error) => {
                console.error('Error in drill-down request:', error);
                return throwError(() => error);
            }),
        );
    }

    getNedistribuite(payload: MatrixFromToPayload): Observable<NedistribuiteResponse> {
        return this.http
            .post<{ errors: boolean; data: NedistribuiteResponse; status_code: number }>(this.nedistribuiteUrl, payload)
            .pipe(
                map((response) => response.data),
                catchError((error) => {
                    console.error('Error in nedistribuite request:', error);
                    return throwError(() => error);
                }),
            );
    }

    getNedistribuiteDrillDown(payload: NedistribuiteDrillPayload): Observable<NedistribuiteDrillResponse> {
        return this.http.post<NedistribuiteDrillResponse>(this.nedistribuiteDrillDownUrl, payload).pipe(
            catchError((error) => {
                console.error('Error in nedistribuite drill-down request:', error);
                return throwError(() => error);
            }),
        );
    }
}
